import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, Input, Inject } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { TableEditBase } from '../../../_infrastructure/TableEdit/TableEditBase';
import { DocumentationPMComponent } from './documentation-pm.component';
import { isNotNullOrUndefinedOrEmpty, isNullOrUndefined } from '../../../_infrastructure/objectUtils';

import { ControlContainer, NgForm } from '@angular/forms';
import { ModalService } from '../../../_infrastructure/Modal/ModalService';
import { DocumentsHandlerService } from '../../../_infrastructure/Documents/DocumentHandlerService';
import { AlertService } from '../../../_infrastructure/Alerts/alert.service';
import { LoadingMaskService } from '../../../_infrastructure/LoadingMask/LoadingMaskService';
import { SubscriberInformationService } from '../../../_infrastructure/SubscriberInfo/SubscriberInformationService';
import * as pdfjsLib from 'pdfjs-dist/build/pdf.mjs';
import { TranslateService } from '@ngx-translate/core';
import { PersonType } from '../../../_infrastructure/Models/const.personType';
import { DropdownsValues } from '../../../_infrastructure/Dropdowns/const.dropdowns';
import { BeneficiaryItem } from '../../../_infrastructure/Models/beneficiary-item';
import { SecurityService } from '../../../_infrastructure/Security/SecurityService';
import { LegalRepresentationState } from '../../../_infrastructure/Beneficiaries/legal-representation-state.service';



@Component({
  selector: 'documentation-table-edit-pm',
  templateUrl: './documentation-table-edit-pm.component.html',
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})
export class DocumentationTableEditPMComponent extends TableEditBase<models.DocumentVM_PM> implements OnInit, OnDestroy {

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.fileTypes)
  public fileTypes: models.DimensionVM[];



  @Input() public isMandatoryDocumentation : boolean;
  @Input() public isWorkflowOnSubscriber : boolean;
  @Input() public isReadonly: boolean = false;
  @Input() public isIncapacity: boolean = false;
  @Input() public isWorkflowMandatory: boolean = false;
  @Input() public workflowInstanceId: number;
  @Input() public workflowCode: string;
  public uploadedFile: File;
  public subscriber: models.SubscriberInformationVM;
  public invalidFileFormat: boolean = false;
  public invalidFileSize: boolean = false;
  public invalidExceedsFileSize: boolean = false;
  public invalidPDFFile: boolean = false;


  private MAX_FILE_SIZE: number = 8388608;

  public beneficiariesList: BeneficiaryItem[] = [];
  public designationTypes: models.Options[] = [];

  public documentsValue = DropdownsValues.dropListDocuments;
  constructor(@Inject(DocumentationPMComponent) private parent: Component, private modalService: ModalService,
    private documentService: DocumentsHandlerService, private alertService: AlertService,
    private activeRoute: ActivatedRoute, private loadingMaskService: LoadingMaskService,
    private securityService: SecurityService,
    private subscriberInfoService: SubscriberInformationService, private http: HttpClient, private translateService: TranslateService) {
    super(parent, modalService);
    
    this.subscriberInfoService.getCurrentSubscriber().subscribe((subscriber) => {
      this.subscriber = subscriber;
    });
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.uploadedFile = null;
    this.buildBeneficiariesList();
    this.getFilteredDesignationTypes();
  }



  ngOnDestroy(): void {
  }

  private buildBeneficiariesList() {
    this.beneficiariesList = this.parent['parentWorkflow']?.workflowInstance.StepBeneficiary.Beneficiary?.beneficiaryList
      .filter((el: models.BeneficiaryListVM) => el.stateRL != LegalRepresentationState.RepresentaçaoIndeferida)
      .map(el => {
        const newBeneficiary: BeneficiaryItem = {
          value: el.beneficiaryID,
          description: el.beneficiaryName,
          name: el.beneficiaryName,
          type:"Beneficiary"
        };
        return newBeneficiary;
      });

   // Add the deceased to the list
    const deceasedIdentification = this.parent['parentWorkflow']?.workflowInstance.StepDeceased.DeceasedIdentification;
    const deceased: BeneficiaryItem = {
      value: PersonType.Deceased,
      description: deceasedIdentification.subscriberName,
      name: deceasedIdentification.subscriberName,
     type:"Deceased"
    };
    this.beneficiariesList.push(deceased);

    //Add sender if not on the list
    const senderIdentification = this.parent['parentWorkflow']?.workflowInstance.StepSender.SenderIdentification;
    const existeOnList = this.itemList.filter(el => el.ownerName == senderIdentification.name).length > 0;

    if (existeOnList) {
      const sender: BeneficiaryItem = {
        value: PersonType.Sender,
        description: senderIdentification.name + " - Remetente",
        name: senderIdentification.name,
        type: "Sender"
      };
      this.beneficiariesList.push(sender);

    }
  }


  private getFilteredDesignationTypes() {
    let parentDropdowns = this.parent['parentWorkflow']['workflowDropdowns'];
    for (let i = 0; i < parentDropdowns.options.length; i++) {
      if (parentDropdowns.options[i]['dropdown'] === 'dropListDocuments') {
        if (!this.isWorkflowMandatory) {
          if (this.isWorkflowOnSubscriber) {
            if (parentDropdowns.options[i]['type'] === '002')
              this.designationTypes.push(parentDropdowns.options[i]);
          } else {
            if (parentDropdowns.options[i]['type'] === '001')
              this.designationTypes.push(parentDropdowns.options[i]);
          }
        } else {
          if (parentDropdowns.options[i]['type'] === '001' || parentDropdowns.options[i]['type'] === '002')
            this.designationTypes.push(parentDropdowns.options[i]);
        }
      }
    }
  }

  public hasIfedoraChave(chave: string): boolean {
    let result = false;
    if (isNotNullOrUndefinedOrEmpty(chave)) {
      const num = parseInt(chave);
      result = num > 0;
    }
    return result;
  }


  onFileSelected(event: any) {
    this.setFile(event.target.files[0]);
  }

  onFileDropped(file: File) {
    this.setFile(file);
  }

  private async setFile(file: File) {
    this.invalidFileFormat = false;
    this.invalidFileSize = false;
    this.invalidPDFFile = false;

    if (!this.validatePDFFile(file)) {
      this.invalidFileFormat = true;
      return;
    } else if (this.validatePDFExceedsFileSize(file)) {
      this.invalidExceedsFileSize = true;
      return;
    } else {
      let fileCheck = await this.checkIfFileIsEmpty(file);
      if (fileCheck === "EmptyPDF") {
        this.invalidFileSize = true;
        return;
      } else if (fileCheck === "InvalidPDF") {
        this.invalidPDFFile = true;
        return;
      }
    }

    this.uploadedFile = file;
    this.item.fileName = this.uploadedFile.name;
    this.item.fileSizeKB = Math.round(this.uploadedFile.size / 1024);
    this.item.file = this.uploadedFile;
    if (!this.item.filePath) {
      this.item.filePath = this.uploadedFile.name;
    }

  }

  private validatePDFExceedsFileSize(file: File) {
    return file.size > this.MAX_FILE_SIZE;
  }

  private validatePDFFile(file: File) {
    return file.type === 'application/pdf';
  }

  private async checkIfFileIsEmpty(file: File): Promise<string> {
    pdfjsLib.GlobalWorkerOptions.workerSrc = "pdf.worker.mjs";
    if (!(<any>Promise).try) {
      (<any>Promise).try = (fn, ...args) => new Promise((res, rej) => {
        try { res(fn(...args)); } catch (e) { rej(e); }
      });
    }
    var fileReader = new FileReader();
    if (file.type === 'application/pdf') {
      fileReader.readAsArrayBuffer(file);

      return new Promise(function (resolve, reject) {
        fileReader.onloadend = async function (ev) {
          let base64Data = fileReader.result as ArrayBuffer;
          const countPromises = [];

          if (base64Data.byteLength != 0) {
            //Códigos dos possíveis objetos de imagens presentes em ficheiros PDF
            var pdfImgObjCodes = [74, 75, 83, 84, 89, 85, 88, 86, 87, 82, 90, 66];

            let pdfProcessing: Int8Array = new Int8Array(base64Data as ArrayBuffer);
            const pdf = await pdfjsLib.getDocument(pdfProcessing);
            try {
              for (let i = 1; i <= (await pdf.promise).numPages; i++) {
                const page = await (await pdf.promise).getPage(i);

                //Verificar se o ficheiro PDF contém conteúdo de texto
                const textContent = await page.getTextContent();
                countPromises.push(textContent.items.map((s: any) => s.str).join(''));

                ////Verificar se o ficheiro PDF contém conteúdo de imagens
                const imgContent = await page.getOperatorList();
                imgContent.fnArray.map(q => {
                  if (pdfImgObjCodes.includes(q))
                    countPromises.push('Img');
                });
              }
            } catch (e) {
              resolve("InvalidPDF");
            }
          } else {
            resolve("EmptyPDF");
          }

          await Promise.all(countPromises).then(function (e) {
            let pdfContent = e.join('');

            if (pdfContent !== ' ') {
              resolve("ValidPDF");
            } else {
              resolve("EmptyPDF");
            }
          })
        }
      })

    }
  }


  emitListChange(isEdit : boolean): void {
    if (isEdit)
      this.itemList.splice(this.editIndex, 1, this.item);
    else
      this.itemList.push(this.item);

    this.listChanged.emit(this.itemList);
  }

  onEdit(isEdit: boolean) {
    //Necessário setar o touched em todos os inputs no seguinte de forma a que as mensagens de erro apareçam
    super.markTouched();

    if (!super.checkValid())
      return;

    if (this.item.designationTypeCode == this.documentsValue.CertidaoNascRequerente // "DPE012"
      || this.item.designationTypeCode == this.documentsValue.CertidaoNascFalecido // "DPE004"
      || this.item.designationTypeCode == this.documentsValue.CertidaoNascReprLegal // "DPE016"
    ) {
      this.item.fileDescription = this.item.fileDescription.toUpperCase();
    }
    //If a file was uploaded
    if (!isNullOrUndefined(this.uploadedFile)) {
      // TODO: Is throwing an error, BE must resolves this 
      this.http.get('api/Workflow/ValidateInstance', { params: { workflowInstanceID: this.parent['parentWorkflow']?.['workflowInstanceId'], role: this.parent['parentWorkflow'].instanceRole } })
        .subscribe((res: any) => {
          // RES é o resultado que vem do BE, decisão para continuar ou não
          if (res.message == 'OK') {
            this.loadingMaskService.setShowLoading(true, false);
            let numUtente = null;
            const numUtenteUser = this.securityService.userDetails.utente;
            //if (numUtenteUser == undefined || numUtenteUser == null || numUtenteUser?.length == 0) {
              const instance: models.WorkflowTemplateVM_PM = this.parent['parentWorkflow']?.['workflowInstance'];
              numUtente = instance.StepDeceased.DeceasedIdentification.subscriberNumber;
            //} else {
            //  numUtente = this.subscriber.numUtente;
            //}
            this.documentService.UploadFile_PM(this.uploadedFile, this.workflowInstanceId.toString(), numUtente, this.item.designationTypeCode).subscribe(result => {
              this.loadingMaskService.setShowLoading(false);
              if (result.stateCode == "OK") {
                this.item.fileID = result.fileID;
                if (!isEdit) this.item.isMandatoryFile = false;
                this.emitListChange(isEdit);
              }
              else {
                this.alertService.error(result.message);
              }
            }, error => this.loadingMaskService.setShowLoading(false));
          } else {
            //this.alertService.error(this.translateService.instant("Workflow.IsAlreadySubmited"));
            this.alertService.error(res.message);
          }
        });

      
    }
    else {
      this.emitListChange(isEdit);
    }
  }


  onRemove(isEdit: boolean) {

    var listToAlter = [...this.itemList];

    if (this.isEdit) {
      if (this.item.isMandatoryFile.toString() != 'true') {
        listToAlter.splice(this.editIndex, 1);
        this.listChanged.emit(listToAlter);
      } else {
        this.onClearFile(this.isEdit);
      }

    }



    this.listChanged.emit(listToAlter);
  }



  downloadDocument() {
    if (!isNullOrUndefined(this.item.fileID) && isNotNullOrUndefinedOrEmpty(this.item.fileID))
      this.documentService.DownloadFile_PM(this.item.fileID.toString(), this.item.fileName, this.workflowInstanceId.toString(), this.subscriber.subscriberNumber, this.workflowCode);
  }


  onClearFile(isEdit: boolean, emit: boolean = false) {

    this.uploadedFile = null;

    function clearItem(itm: models.DocumentVM_PM) {
      itm.fileName = '';
      itm.file = null;
      itm.fileID = null;
      itm.fileDescription = "";
      itm.fileObservation = "";
      itm.filePath = "";
    }

    clearItem(this.item);
    

    if ((this.editIndex !== null) && !isNaN(this.editIndex)) {
      clearItem(this.itemList[this.editIndex]);
    }

    if (emit) {
      this.listChanged.emit(this.itemList);
    }

    return false;

  }


  public removeDisabled(): boolean {
    if (!this.isEdit) return false;
    return (this.item.isMandatoryFile.toString().toLowerCase() == 'true');
  }



 


  public docDesignationChanged(): void {
    this.item.designationTypeDescription = this.designationTypes
      .find(el => el.value == this.item.designationTypeCode).description;
  }


  public nameChanged(): void {
    const beneficiary = this.beneficiariesList
      .find(el => el.value == this.item.beneficiaryID);
    this.item.ownerName = beneficiary.name;
    this.item.fileOwnerTypeCode = beneficiary.type;
  }
}


